import { Link } from "react-router-dom";

export default function Stories() {
  return (
    <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl">
        <div className="ie-overline text-brand-accent mb-4">
          Journal
        </div>

        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1.05]">
          Stories
        </h1>

        <p className="text-text-secondary text-base md:text-lg leading-relaxed mt-6">
          Notes from the house — about clothing, craftsmanship, culture and
          the quiet details that shape INDUS EIRENE.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mt-20">
        <article className="border border-border p-7 md:p-10">
          <div className="ie-overline text-brand-accent mb-5">
            The House
          </div>
          <h2 className="font-serif text-3xl mb-4">
            Where India meets serenity
          </h2>
          <p className="text-text-secondary text-sm leading-7">
            The ideas behind INDUS EIRENE and the visual language that shapes
            the house.
          </p>
        </article>

        <article className="border border-border p-7 md:p-10">
          <div className="ie-overline text-brand-accent mb-5">
            Perspective
          </div>
          <h2 className="font-serif text-3xl mb-4">
            The art of wearing less
          </h2>
          <p className="text-text-secondary text-sm leading-7">
            A reflection on restraint, repetition and building a wardrobe
            around pieces that endure.
          </p>
        </article>
      </div>

      <div className="mt-12">
        <Link to="/shop" className="ie-btn-primary">
          Explore the collection
        </Link>
      </div>
    </div>
  );
}